import { Controller } from "@hotwired/stimulus"
export default class extends Controller {
    static targets = ['stickycontent'];
    connect() {
        this.observer = new IntersectionObserver(
            this.handleIntersection.bind(this),
            {
                threshold: 0.3,
                rootMargin: '0px'
            }
        );

        // Observe tous les .u-block enfants
        this.element.querySelectorAll('.u-block').forEach(block => {
            this.observer.observe(block);
        });

        this.onScroll = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.onScroll();
    }

    disconnect() {
        this.observer.disconnect();
        window.removeEventListener('scroll', this.onScroll);
    }
    onScroll() {
        const parentRect = this.element.getBoundingClientRect();
        const target = this.stickycontentTarget;
        if(parentRect.top <= 0) {
            target.style.position = "fixed";
        } else {
            target.style.position = "absolute";
        }
    }
    handleIntersection(entries) {
        entries.forEach(entry => {
            const block = entry.target;
            const rect  = block.getBoundingClientRect();

            // Visible si dans le viewport OU au dessus
            const isVisible = entry.isIntersecting || rect.top < 0;

            if (isVisible) {
                block.setAttribute('data-visible', 'true');
                // Une fois visible on arrête d'observer
                this.observer.unobserve(block);
            }
        });
    }
}